import PawnList from "./PawnList";

export default PawnList;
